/**
 * Константы для Aidar
 * Все новые константы модальных окон и другие константы Aidar добавляются сюда
 * чтобы избежать конфликтов с другими разработчиками в основном файле констант
 */

// Страницы Aidar
export const PAGES_AIDAR = {
  tierReasonReport: "/tier-reason-report",
  tierFactFirst: "/tier-fact-first",
};

// Модальные окна для управления этажами и группами работ
export const MODAL_NAMES_AIDAR = {
  // Управление этажами
  AddWorkGroupLevel: "AddWorkGroupLevel",
  EditWorkGroupLevel: "EditWorkGroupLevel",

  // Просмотр задач
  ViewWorkGroupTasks: "ViewWorkGroupTasks",

  // Timeline
  EditTierFactTimeline: "EditTierFactTimeline",
  EditLaborFact: "EditLaborFact",

  // Группы работ и задачи
  AddWorkGroupDict: "AddWorkGroupDict",
  EditWorkGroupDict: "EditWorkGroupDict",
  AddTaskDict: "AddTaskDict",
  EditTaskDict: "EditTaskDict",

  // Причины невыполнения
  AddReason: "AddReason",
  EditReason: "EditReason",

  // Заявки поставщикам
  SupplierRequestDetail: "SupplierRequestDetail",
  SelectProjectGrouped: "SelectProjectGrouped",
  CreateInvoice: "CreateInvoice",
  ViewInvoice: "ViewInvoice",
  ViewRealize: "ViewRealize",
  SelectMaterial: "SelectMaterial",
  SupplierRequestAddMaterial: "SupplierRequestAddMaterial",

  // Добавляйте новые модальные окна ниже:
  // ...
};
